import { isEmpty } from "@thinkvn/utils";
import { isArray, isObject } from "./is.mjs";
import { notUndefined } from "./guards.mjs";
export const hasOwnProperty = (obj, v) => {
  if (!isObject(obj))
    return false;
  return Object.prototype.hasOwnProperty.call(obj, v);
};
export const has = (object, property) => {
  return notUndefined(object[property]);
};
export const omit = (obj, ...keys) => {
  const _obj = { ...obj };
  keys.forEach((key) => delete _obj[key]);
  return _obj;
};
export const pick = (obj, ...keys) => {
  const _obj = {};
  keys.forEach((key) => {
    _obj[key] = obj[key];
  });
  return _obj;
};
export const get = (obj, path, defaultVal) => {
  const _path = isArray(path) ? path : path.replace(/(\[(\d)\])/g, ".$2").replace(/^\./, "").split(".").filter((i) => i.length);
  if (obj && _path.length) {
    return get(obj[_path.shift()], _path, defaultVal);
  }
  return obj === void 0 ? defaultVal : obj;
};
const entries = (object) => {
  return Object.entries(object);
};
export const map = (object, callback) => {
  return Object.fromEntries(entries(object).map(([key, value]) => {
    return [key, callback.call(object, value, key, object)];
  }));
};
export const filter = (object, callback) => {
  return Object.fromEntries(entries(object).filter(([key, value]) => {
    return callback.call(object, value, key, object);
  }));
};
export const forEach = (data, callback) => {
  entries(data).forEach(([key, value], index) => {
    callback.call(data, value, key, index, data);
  });
};
export const first = (data) => {
  if (isEmpty(data))
    return [null, null];
  return entries(data)[0];
};
